import { NotificationConfiguration } from '../notification.templates';

export const MEETING_AGENDA_FEEDBACK_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> has shared feedback on the agenda <b>{title}</b> with you.`,
  email: {
    ctaKey: 'go_to_feedback',
  },
};
